import React, {
  ClassType,
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import ChatService from "../routes/teamWork/ChatPage/Base/ChatService";
import { useDispatch, useSelector } from "react-redux";

import AuthContext from "../contexts/AuthContext";
import {
  onNotifyNewMessage,
  onGetUserRoomsWithNewMessage,
  onGetUserRoomsDetailWithNewMessage,
  onSelectRoom,
} from "../appRedux/actions";
import { useLocation } from "react-router-dom";

interface IChatContext {
  signalRConnected: boolean;
}

const ChatContext = React.createContext({ } as IChatContext);

export const useChat = () => {
  return useContext(ChatContext);
};

function ChatProvider(props: any) {
  let location = useLocation();
  const authContext = useContext(AuthContext);
  let userEp = authContext.userEmployeePosition;

  const dispatch = useDispatch();
  const fgChat = useSelector(({ fgChat }: any) => fgChat);

  const [chatService, setChatService] = useState<any>(
    new ChatService(
      notifyNewMessageCallback,
      userConnetionStatusCallback,
      disconnectedCallback
    )
  );

  const [signalRConnected, setSignalRConnected] = useState(false);

  function notifyNewMessageCallback(data: any) {
    dispatch(onNotifyNewMessage(data));
  }

  function userConnetionStatusCallback(data: any) {
    // console.log("userConnetionStatusCallback", data);
  }

  function disconnectedCallback(retult: boolean) {
    setSignalRConnected(retult);
  }

  // Start SignalR
  useEffect(() => {
    async function startSignalRConnection() {
      let res = (await chatService.startConnection()) as boolean;
      return setSignalRConnected(res);
    }

    if (!signalRConnected && window.config.signalRurl && userEp.personCode) {
      startSignalRConnection();
    }
  }, []);

  useEffect(() => {
    // console.log("signalRConnected", signalRConnected);
    if (signalRConnected && window.config.signalRurl && userEp.personCode) {
      dispatch(onGetUserRoomsWithNewMessage());
    }
  }, [signalRConnected]);

  useEffect(() => {
    let ids = fgChat.userRoomsDetailWithNewMessage.map((item: any) => item.Id);
    fgChat.userRoomsWithNewMessage.map((roomId: any) => {
      if (!ids.includes(roomId))
        return dispatch(onGetUserRoomsDetailWithNewMessage(roomId));
    });
  }, [fgChat.userRoomsWithNewMessage.length]);

  // Cleanup Data
  useEffect(() => {
    if (location.pathname !== "/team-work/chat" && fgChat.selectedRoom) {
      dispatch(onSelectRoom(null));
    }
  }, [location]);

  useEffect(() => {
    if (!fgChat.signalRIsDisconnected) {
      setSignalRConnected(false);
    }
  }, [fgChat.signalRIsDisconnected]);

  return (
    <ChatContext.Provider
      value={{
        signalRConnected,
      }}
    >
      {props.children}
    </ChatContext.Provider>
  );
}

const ChatConsumer = ChatContext.Consumer;

export { ChatProvider, ChatConsumer };

export default ChatContext;
